import { render, staticRenderFns } from "./UserDashboardProjects.vue?vue&type=template&id=31f9a30b&scoped=true&"
import script from "./UserDashboardProjects.vue?vue&type=script&lang=js&"
export * from "./UserDashboardProjects.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardProjects.vue?vue&type=style&index=0&id=31f9a30b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9a30b",
  null
  
)

export default component.exports